import type { IconData } from '@stacksjs/iconify-core'

export const disableProtectionSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.768 1.232a2.5 2.5 0 0 0-3.536 3.536l40 40a2.5 2.5 0 0 0 3.536-3.536l-4.149-4.148c3.748-4.64 5.844-10.538 5.88-16.693l.001-.591c0-5.232-.401-9.66-.712-12.302c-.25-2.137-1.6-4.128-3.965-4.664C39.06 2.207 33.787 1.5 24 1.5c-9.604 0-14.861.681-17.666 1.299zM1.5 19.8c0-4.02.237-7.565.488-10.191L34.76 42.381a25 25 0 0 1-1.975 1.164c-1.534.812-3.091 1.541-4.56 2.07c-1.451.523-2.912.885-4.225.885s-2.774-.362-4.224-.885c-1.47-.529-3.027-1.258-4.56-2.07c-8.57-4.536-13.66-13.532-13.715-23.154z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default disableProtectionSolid
